import {
  API_URL_TRAINING_WISH_FREE as freeWishUrl,
  API_URL_TRAINING_WISHES_PATHWAY as pathwayUrl,
  API_URL_TRAINING_WISHES as wishUrl,
} from 'constants/api'
import type QueryClient from 'services/query'
import { mapFreeWishPayload, mapPayload } from 'services/trainingWish'
import { buildURL } from 'services/url'

interface Params {
  id: string
  wishId: string
  lang: string
  from?: string
}

export const createWish =
  (client: QueryClient) =>
  async ({ params, request }: { params: Params; request: Request }) => {
    const { id, wishId, lang } = params

    const reqUrl = new URL(request.url)
    const queryParams = new URLSearchParams(reqUrl.search)

    const formData = await request.formData()
    formData.delete('safetyStandalone')
    formData.delete('canViewAccreditationBoard')

    // Special case for training pathway
    const pathway = formData.get('pathway') === 'true'
    formData.delete('pathway')

    const payload = mapPayload({ formData, trainingId: Number(id) })

    try {
      const url = wishId ? `${wishUrl}/${wishId}` : pathway ? pathwayUrl : wishUrl

      await client.post(buildURL(url, queryParams), payload)
    } catch (e: any) {
      return { error: e.response }
    }

    window.location.href = queryParams.get('from') ?? `/${lang}/needs-summary`

    return null
  }

export const createFreeWish =
  (client: QueryClient) =>
  async ({ params, request }: { params: Params; request: Request }) => {
    const { wishId, lang } = params

    const reqUrl = new URL(request.url)
    const queryParams = new URLSearchParams(reqUrl.search)

    const formData = await request.formData()
    const payload = mapFreeWishPayload({ formData })

    try {
      const url = wishId ? `${freeWishUrl}/${wishId}` : freeWishUrl

      await client.post(buildURL(url, queryParams), payload)
    } catch (e: any) {
      return { error: e.response }
    }

    window.location.href = queryParams.get('from') ?? `/${lang}/needs-summary`

    return null
  }
